export enum StepRouteEnum {
  Home = 'home',
  ContactSetting = 'contact-setting',
  Payment = 'payment',
  Confirmation = 'confirmation',
}
